<template>
    <div class="jyml">
        <Header :navbar="activeHeader" @navTarget="getNavbar"></Header>
        <div class="header">


            <span @click="to" style="cursor: pointer;">
                <i class="el-icon-arrow-left 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        "
                    style="font-weight: 600;font-size: 18px;margin-left: 10px;"></i>返回</span>
            <span style="margin-left: 50px;margin-right: 10px;"> {{ courseInfo.title }} ></span>
            <span> 课程讲义</span>
        </div>
        <div class="conten" v-loading="loading" element-loading-text="文件下载中">

            <div class="ml">
                <div class="ml_txtx">课程讲义目录</div>
                <div class="ml_btn" @click="aaa">下载全部

                </div>
            </div>
            <div class="tree">
                <el-tree ref="mylist" :auto-expand-parent='true' :default-expand-all="false" :render-content="renderContent"
                    :data="list" :props="defaultProps" highlight-current node-key="id"
                    :default-expanded-keys="defaultExpandedKeys"></el-tree>


            </div>
        </div>

    </div>
</template>

<script>
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import axios from 'axios';

import Header from "@/components/Header.vue";
import {
    getCourseDetailCatalogue, getCourseDetailIntroduction
} from '@/api/index.js';


export default {
    name: "",
    components: {
        Header,
    },
    data() {
        return {
            loading: false,
            defaultExpandedKeys: [],
            defaultProps: {
                children: 'children',
                label: 'title'
            },
            activeHeader: "courseDetail",

            recordId: "", deptId: "",
            token: "",
            list: [], courseInfo: {}, listARR: [], imgurl: []


        }
    },
    created() {
        // var loginInfo = window.localStorage.getItem("user");
        // if (loginInfo) {
        //     var userInfo = JSON.parse(loginInfo);
        //     this.deptId = userInfo.deptId;
        //     this.token = userInfo.token;
        // }
        this.deptId = window.localStorage.getItem('TopDeptId');
        this.token = window.localStorage.getItem('token');
        this.recordId = this.$route.params.id;


    }, mounted() {
        this.getCourseIntroduction()
        this.getList()
    },
    methods: {
        //下载图片
        async downloadImage(url, name) {
            try {
                const response = await fetch(url);
                const blob = await response.blob();

                let extension = 'jpg'; // 默认后缀为 jpg

                // 从响应的头信息中获取 Content-Type
                const contentType = response.headers.get('Content-Type');
                if (contentType) {
                    if (contentType.includes('image/jpeg')) {
                        extension = 'jpg';
                    } else if (contentType.includes('image/png')) {
                        extension = 'png';
                    } else if (contentType.includes('image/gif')) {
                        extension = 'gif';
                    }
                    // 可根据需要添加其他图片格式的判断
                }

                // 生成文件名
                const fileName = `${name}.${extension}`;

                // 创建一个链接元素
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName;

                // 将链接添加到页面并点击触发下载
                document.body.appendChild(link);
                link.click();

                // 清理创建的链接
                document.body.removeChild(link);
            } catch (error) {
                console.error('下载图片出错：', error);
            }
        },
        // 函数用于确定图片的后缀名
        THSIgetImageSuffix(contentType) {
            const typeMap = {
                'image/png': 'png',
                'image/jpeg': 'jpg',
                'image/gif': 'gif',
                'image/webp': 'webp',
                'application/pdf': 'pdf',
                // 添加其他图片类型的映射，如果需要的话
            };

            return typeMap[contentType] || null; // 如果不是图片类型，返回null
        },
        async downloadImagesAndZip(listARR, zipNme = this.courseInfo.title) {
            this.loading = true

            try {
                const zip = new JSZip();
                const imageUrls = listARR; // 确保这是你的图片URL数组

                for (const time of imageUrls) {
                    try {
                        // 发送 HEAD 请求以获取文件的 Content-Type
                        const headResponse = await axios.head(time.url);
                        const contentType = headResponse.headers['content-type'];
                        const imageSuffix = this.THSIgetImageSuffix(contentType);

                        if (imageSuffix) {
                            // 确定图片文件名
                            const fileName = `${time.name}.${imageSuffix}`; // 可以使用时间戳来避免文件名冲突

                            // 获取图片内容并添加到 ZIP 文件中
                            const response = await axios.get(time.url, { responseType: 'blob' });
                            zip.file(fileName, response.data, { binary: true });
                        } else {
                            console.warn(`Unsupported image type detected: ${contentType}`);
                        }
                    } catch (error) {
                        console.error(`Error downloading image from ${time.url}:`, error);
                    }
                }

                // 生成 ZIP 文件并下载
                zip.generateAsync({ type: 'blob' }).then(blob => {
                    saveAs(blob, zipNme ? zipNme + '讲义文件集合' : '讲义文件集合');
                    this.loading = false
                });
            } catch (error) {
                console.error('Error downloading or zipping images:', error);
            }
        },
        async getCourseIntroduction() {
            await getCourseDetailIntroduction(
                this.recordId,
                {},
                {
                    Authorization: this.token,
                    DeptId: this.deptId,
                }
            )
                .then((res) => {
                    if (res.code == 200) {
                        var data = res.data;
                        this.courseInfo = data;

                    }

                })

        },
        getList() {
            getCourseDetailCatalogue(this.recordId,
                {},
                {
                    Authorization: this.token,
                    DeptId: this.deptId,

                }).then(res => {
                    console.log(res.data, '88888888')
                    var data = res.data;
                    this.detalDataForBf(data);
                    this.list = data
                    console.log(this.listARR, '************下载文件包')

                })
        },
        detalDataForBf(data) {

            const deepLevel = {
                1: "章",
                2: "节",
                3: "篇",
                4: "点",
            };
            const numberMap = ["一", "二", "三", "四"];

            if (data && data.length !== 0) {
                data.forEach((item, index) => {

                    if (data[index].recordContentsFileInfo.pdf || data[index].recordContentsFileInfo.jpgs) {

                        // this.listARR.push(
                        //     {
                        //         name: data[index].title,
                        //         url: data[index].recordContentsFileInfo.pdf
                        //             ? data[index].recordContentsFileInfo.pdf.sourceUrl : data[index].recordContentsFileInfo.jpgs[0].sourceUrl
                        //     })


                        if (data[index].recordContentsFileInfo.pdf) {
                            this.listARR.push(
                                {
                                    name: data[index].title,
                                    url: data[index].recordContentsFileInfo.pdf.sourceUrl

                                })
                        } else {
                            console.log(data[index].recordContentsFileInfo.jpgs.length)
                            if (data[index].recordContentsFileInfo.jpgs.length == 1) {
                                this.listARR.push(
                                    {
                                        name: data[index].title,
                                        url: data[index].recordContentsFileInfo.jpgs[0].sourceUrl
                                    })
                            } else {
                                data[index].recordContentsFileInfo.jpgs.forEach((k, i) => {

                                    this.listARR.push({
                                        name: data[index].title + Number(i + 1),
                                        url: k.sourceUrl
                                    })
                                })
                            }
                        }
                    }

                    const addText = deepLevel[String(item.level)];
                    item.title = `第${index + 1}${item.name}：${item.title}`;
                    if (item.children && item.children !== 0) {
                        this.detalDataForBf(item.children);
                    }
                });
            }
            return data;
        },

                 
        handleTreeMenu(data, e) {
            this.imgurl = []
            //  console.log(data.recordContentsFileInfo.pdf.sourceUrl);
            if (data.recordContentsFileInfo.pdf) {
                if (/\.\w+$/.test(data.recordContentsFileInfo.pdf.sourceUrl)) {
                    // 如果有后缀名，则执行相应操作
                    console.log("URL包含后缀名");
                    // 在这里可以添加你的操作
                    window.open(data.recordContentsFileInfo.pdf.sourceUrl)
                } else {
                    this.downloadPDF(data.recordContentsFileInfo.pdf.sourceUrl, data.title)
                    // 如果没有后缀名，则执行其他操作
                    console.log("URL没有后缀名");
                    // 在这里可以添加其他操作
                }
            } else if (data.recordContentsFileInfo.jpgs) {
                // this.downloadImage(data.recordContentsFileInfo.jpgs[0].sourceUrl, data.title)
                //window.open(data.recordContentsFileInfo.jpgs[0].sourceUrl)

                if (data.recordContentsFileInfo.jpgs.length == 1) {
                    // window.open(data.recordContentsFileInfo.jpgs[0].sourceUrl)
                    this.downloadImage(data.recordContentsFileInfo.jpgs[0].sourceUrl, data.title)
                } else {

                    data.recordContentsFileInfo.jpgs.forEach((k, index) => {

                        this.imgurl.push({
                            name: data.title + "-" + Number(index + 1),
                            url: k.sourceUrl
                        })
                    })
                    this.downloadImagesAndZip(this.imgurl, data.title)
                }
            }

        },
        downloadPDF(backendPDFURL, name) {
            // 提取文件名
            const fileName = backendPDFURL.substring(backendPDFURL.lastIndexOf('/') + 1);

            // 判断是否有后缀名
            const fileExtension = fileName.split('.').pop();

            // 设置下载文件名，如果没有后缀名，则默认为".pdf"
            const downloadFileName = `${name}.pdf`;

            // 使用Blob对象创建一个下载链接
            const xhr = new XMLHttpRequest();
            xhr.open('GET', backendPDFURL, true);
            xhr.responseType = 'blob';
            xhr.onload = function () {
                if (this.status === 200) {
                    const blob = new Blob([this.response], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    // 添加Content-Disposition标头告知浏览器下载文件并指定文件名
                    a.setAttribute('download', downloadFileName);
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                }
            };
            xhr.send();
        },
        renderContent(h, { node, data, store }) {

            return (
                <span class="custom-tree-node">
                    <div class="custom-tree-node-title">{node.label} </div>
                    <div class='aaaaaaaaaaa'></div>
                    <div class='treeList' v-show={node.data.existVideoOrAudio}>
                        <div v-show={node.data.level !== 1} class="img-r img-r-p" onclick={(e) => this.handleTreeMenu(node.data, e)}>
                            <div class='xz' v-show={data.recordContentsFileInfo.pdf || data.recordContentsFileInfo.jpgs}>下载</div>
                        </div>

                    </div>

                </span >);
        },

        getNavbar(target, jumpValue = null, name) {
            this.activeHeader = target;
            if (jumpValue) {
                this.courseClassId = Number(jumpValue);
            }
            if (name) {
                this.$router.push({
                    path: "/"
                })
            }
        },
        to() {
            this.$router.go(-1);
        },
        //下载全部
        aaa() {
            if (this.listARR.length) {
                console.log(this.listARR)
                this.downloadImagesAndZip(this.listARR)

            } else {
                this.$message.error('暂无下载数据');

            }
        },
    }
}
</script>
<style scoped lang="less">
.jyml {
    width: 1200px;
    padding-top: 100px;
    min-height: 800px;
    margin: 0 auto;


    .header {
        height: 50px;
        margin-top: 20px;
        background: #fff;
        line-height: 50px;
        // border-radius: 5px;
    }

    .conten {
        width: 100%;
        min-height: 750px;
        background: #fff;
        margin-top: 30px;
    }

    .ml {
        height: 50px;
        width: 100%;
        display: flex;
        justify-content: space-between;

        .ml_txtx {
            margin-top: 20px;
            width: 120px;
            height: 30px;
            line-height: 35px;
            border-left: 6px solid #000;
            text-align: right;
        }

        .ml_btn {
            cursor: pointer;
            margin-top: 20px;

            margin-right: 20px;
            text-align: center;
            width: 120px;
            background: #4f79ed;
            height: 35px;
            line-height: 35px;
            text-align: center;
            border-radius: 20px;
            color: #fff;
        }
    }

    .tree {
        margin-top: 40px;
        height: 650px;

        overflow: hidden;
        overflow-y: auto;
    }
}

.collapse-icon {
    font-size: 25px;
    display: inline-block;
    color: #fff;
    margin-right: 5px;
}

.tree-menu-item-active {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #2b85e4;
}

/deep/ .free-audition {
    display: flex;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 150px;
    height: 30px;
    //   background-color: #3e63ee;
    color: #fff;
    padding: 2px 5px;

    .img-r {
        width: 20px;
        height: 20px;
        margin-top: 7px;
    }

    .img-r-p {

        // background-image: url('../assets/img/play1.png');
        // background-size: 100% 100%;
        .xz {
            width: 150px;
            height: 20px;


            color: #fff;
        }
    }



    .free-audition {
        color: #3e63ee;
        background-size: 100% 100%;
        margin-left: 20px
    }

    .img-r-w {
        // background-image: url('../assets/img/write.png');
        // background-size: 100% 100%;
        margin-right: 60px;


        .el-icon-edit-outline {
            font-size: 25px;
            font-weight: 600;
            color: #3e63ee;
        }
    }
}

// /deep/ .free-audition {
//     position: absolute;
//     right: 0;
//     // top: 50%;
//     transform: translateY(-50%);
//     margin-top: 10px;
//     color: #3e63ee;
//     padding: 2px 5px;
// }
.tree-menu-item {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    cursor: pointer;
}







/deep/ .el-tree-node__content {
    height: 50px !important;
    // font-size: 20px !important;
    position: relative;
    border-bottom: 1px solid #eaeaee !important;

}

/deep/ .custom-tree-node-time {
    padding-left: 10px;
    font-size: 14px;
    color: rgb(131, 131, 133);

}

/deep/ .custom-tree-node-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 558px;
}

/deep/ .free-audition {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%)
}

.treeList {
    position: relative;
}

/deep/ .el-icon-edit-outline {
    position: absolute;
    top: 10px;
    right: 15%;
    font-size: 25px;
    font-weight: 600;
    color: #3e63ee;
}

/deep/ .xz {
    position: absolute;
    right: 20px;
    top: 10px;
    text-align: center;
    width: 80px;
    font-size: 13px;
    border: 1px solid #ccc;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 20px;
    color: #000;
}

/deep/ .img-r-l {
    position: absolute;
    right: 2%;
    top: 10px;
}
</style>